import * as React from "react";
import { Hero } from "../components/hero";
import { Layout } from "../layouts";
import HeroBgLeft from "../images/facebook-ads/hero-bg-left.png";
import HeroBgRight from "../images/facebook-ads/hero-bg-right.png";
import { TrustedBy } from "../components/trusted-by";
import { FiveStarRated } from "../components/five-star-rated";
import { OurWhiteLabel } from "../components/our-white-label";
import { Elevate } from "../components/elevate";
import { EasyAs } from "../components/services/esay-as";
import {
  easyAsFeatures,
  faqs,
  getItAllContents,
  brands,
  trustedByEntities,
} from "../contents/facebook-ads";
import { SectionAction } from "../components/services/section-action";
import { Faqs } from "../components/faqs";
import { GetItAll } from "../components/services/get-it-all";
import { ratedFeatures } from "../contents/facebook-ads";

const SEOPage = () => (
  <Layout
    title="White Label Facebook Ads Management for Agencies | 100% USA-Based"
    description="White Label Facebook Ads Management for ambitious agency owners, 100% USA-Based. Get our pricing and schedule your free consultation now!"
  >
    <Hero
      title="White Label Facebook Ads to Grow Your Agency Faster"
      text="Successful agencies work with Agency Elevation to accelerate growth and increase profit."
      bgLeft={HeroBgLeft}
      bgRight={HeroBgRight}
    />
    <TrustedBy trustedByEntities={trustedByEntities} />
    <FiveStarRated features={ratedFeatures} />
    <EasyAs
      title="White Label Facebook Ads
			as Easy as 1-2-3"
      text="Start fast and get results quickly with our done-for-you, 100% USA-based white label Facebook Ads service."
      features={easyAsFeatures}
    />
    <OurWhiteLabel title={<>Our White Label Facebook Ads Are a No-Brainer</>} />
    <GetItAll {...getItAllContents} />
    <SectionAction
      title={
        <>
          Where We Do
          <br />
          White Label Facebook Ads
        </>
      }
      brands={brands}
    />
    <Elevate />
    <Faqs faqs={faqs} />
  </Layout>
);

export default SEOPage;
